import { render, staticRenderFns } from "./UnitManagers.vue?vue&type=template&id=5c4e35f8&"
import script from "./UnitManagers.vue?vue&type=script&lang=ts&"
export * from "./UnitManagers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports